export const siteStats = [
  { id: "stat-1", label: "已收录平台", value: "128", suffix: "个", icon: "ri-layout-grid-line" },
  { id: "stat-2", label: "覆盖话题分类", value: "6", suffix: "大类", icon: "ri-price-tag-3-line" },
  { id: "stat-3", label: "用户参与评分", value: "9.4", suffix: "万次", icon: "ri-star-smile-line" },
  { id: "stat-4", label: "榜单更新", value: "每周", suffix: "1 次", icon: "ri-refresh-line" },
];

export const navLinks = [
  { id: "nav-home", label: "首页", href: "#home" },
  { id: "nav-rank", label: "人气榜", href: "#rank" },
  { id: "nav-category", label: "主题分类", href: "#category" },
  { id: "nav-review", label: "口碑评测", href: "#review" },
  { id: "nav-guide", label: "选择指南", href: "#guide" },
  { id: "nav-faq", label: "常见问题", href: "#faq" },
  { id: "nav-about", label: "关于我们", href: "#about" },
];

export const categories = [
  { id: "all", name: "全部", desc: "不限主题，按综合热度排序", icon: "ri-fire-line", count: 128 },
  { id: "general", name: "综合吃瓜", desc: "题材宽、更新快的大杂烩阵地", icon: "ri-restaurant-2-line", count: 34 },
  { id: "entertainment", name: "娱乐八卦", desc: "影视综与艺人动态的讨论集散地", icon: "ri-film-line", count: 27 },
  { id: "tech", name: "科技爆料", desc: "新品、行业内幕与产品拆解", icon: "ri-cpu-line", count: 21 },
  { id: "game", name: "游戏电竞", desc: "赛事风云、版本爆料与圈内话题", icon: "ri-gamepad-line", count: 19 },
  { id: "workplace", name: "职场热议", desc: "打工人的吐槽与行业内情", icon: "ri-briefcase-line", count: 15 },
  { id: "campus", name: "校园话题", desc: "高校动态与学生圈的热门讨论", icon: "ri-graduation-cap-line", count: 12 },
];

export const platforms = [
  {
    id: 1,
    name: "瓜田社",
    slug: "guatian-she",
    category: "general",
    categoryName: "综合吃瓜",
    tagline: "全民吃瓜的第一现场",
    description:
      "老牌综合阵地，话题跨度从娱乐到社会热点都有覆盖。编辑习惯给每条爆料标注时间线，追更一条线索时不容易断片，评论区讨论氛围也相对理性。",
    heat: 98,
    rating: 4.8,
    reviews: 12840,
    updateScore: 96,
    trustScore: 88,
    tags: ["更新快", "话题广", "有追踪时间线"],
    established: "2019",
    badge: "编辑推荐",
  },
  {
    id: 2,
    name: "热浪视界",
    slug: "relang-shijie",
    category: "entertainment",
    categoryName: "娱乐八卦",
    tagline: "把综艺与剧集的热度做成了地图",
    description:
      "以影视综和艺人动态为主，栏目分得细，找某部剧的讨论几乎不用翻页。图文排版舒服，适合只想安静围观、不爱看吵架的用户。",
    heat: 96,
    rating: 4.7,
    reviews: 10620,
    updateScore: 94,
    trustScore: 85,
    tags: ["栏目清晰", "阅读体验好"],
    established: "2020",
    badge: "口碑之选",
  },
  {
    id: 3,
    name: "星探前线",
    slug: "xingtan-qianxian",
    category: "entertainment",
    categoryName: "娱乐八卦",
    tagline: "艺人行程与片场动态的搬运工",
    description:
      "更新节奏快，偏资讯搬运与汇总，适合想第一时间知道发生了什么的人。信息多为二手转载，看的时候建议对照原始来源。",
    heat: 94,
    rating: 4.4,
    reviews: 8730,
    updateScore: 97,
    trustScore: 74,
    tags: ["资讯快", "以转载为主"],
    established: "2021",
    badge: "",
  },
  {
    id: 4,
    name: "码上爆料",
    slug: "mashang-baoliao",
    category: "tech",
    categoryName: "科技爆料",
    tagline: "新品未发先拆的硬核阵地",
    description:
      "聚焦消费电子与互联网行业，供应链消息和产品规格爆料不少。作者习惯把「已证实」和「传闻」分开写，信息可靠度在同类里偏高。",
    heat: 92,
    rating: 4.6,
    reviews: 7240,
    updateScore: 90,
    trustScore: 91,
    tags: ["标注来源", "传闻区分清晰"],
    established: "2018",
    badge: "信息可靠",
  },
  {
    id: 5,
    name: "硬核说客",
    slug: "yinghe-shuoke",
    category: "tech",
    categoryName: "科技爆料",
    tagline: "行业里的人都爱看的深度区",
    description:
      "更偏长文与行业分析，爆料只是引子，重点在于把来龙去脉讲清楚。更新不算频繁，但每篇都值得慢慢读。",
    heat: 89,
    rating: 4.7,
    reviews: 5320,
    updateScore: 78,
    trustScore: 93,
    tags: ["长文分析", "更新较慢"],
    established: "2017",
    badge: "",
  },
  {
    id: 6,
    name: "峡谷情报站",
    slug: "xiagu-qingbaozhan",
    category: "game",
    categoryName: "游戏电竞",
    tagline: "赛事与版本消息一网打尽",
    description:
      "赛事动态、版本改动和选手转会消息更新得很勤，社区氛围偏年轻，梗多热闹。适合边看比赛边刷讨论的用户。",
    heat: 93,
    rating: 4.5,
    reviews: 9110,
    updateScore: 95,
    trustScore: 82,
    tags: ["赛事同步", "社区活跃", "氛围年轻"],
    established: "2020",
    badge: "人气推荐",
  },
  {
    id: 7,
    name: "电竞风眼",
    slug: "dianjing-fengyan",
    category: "game",
    categoryName: "游戏电竞",
    tagline: "转会期最热闹的那张桌子",
    description:
      "转会与战队内部消息集中地，爆料密但真伪掺半，建议当成线索池而不是结论。讨论区战斗力很足，看热闹可以，别太当真。",
    heat: 87,
    rating: 4.1,
    reviews: 4890,
    updateScore: 92,
    trustScore: 68,
    tags: ["转会消息多", "需自行甄别"],
    established: "2022",
    badge: "",
  },
  {
    id: 8,
    name: "打工人茶馆",
    slug: "dagongren-chaguan",
    category: "workplace",
    categoryName: "职场热议",
    tagline: "讲行业真话，喝打工人的茶",
    description:
      "以行业生态、公司内情和职场经历分享为主，投稿质量参差但真实感强。适合在跳槽或选行业前当参考读物。",
    heat: 90,
    rating: 4.6,
    reviews: 6180,
    updateScore: 85,
    trustScore: 84,
    tags: ["真实投稿", "行业参考"],
    established: "2019",
    badge: "编辑推荐",
  },
  {
    id: 9,
    name: "工位小喇叭",
    slug: "gongwei-xiaolaba",
    category: "workplace",
    categoryName: "职场热议",
    tagline: "轻量吐槽，随手一看",
    description:
      "短平快的职场吐槽合集，阅读门槛低，通勤路上刷正好。深度内容不多，图个解压可以。",
    heat: 84,
    rating: 4.2,
    reviews: 3960,
    updateScore: 88,
    trustScore: 76,
    tags: ["轻阅读", "解压向"],
    established: "2021",
    badge: "",
  },
  {
    id: 10,
    name: "校园风声",
    slug: "xiaoyuan-fengsheng",
    category: "campus",
    categoryName: "校园话题",
    tagline: "高校里的热门话题集散地",
    description:
      "以校园活动、招生动态和学生讨论为主，地域性强，找自己学校的板块很方便。内容偏轻，更新随学期节奏起伏。",
    heat: 86,
    rating: 4.3,
    reviews: 4270,
    updateScore: 82,
    trustScore: 80,
    tags: ["分校区板块", "季节性活跃"],
    established: "2020",
    badge: "",
  },
  {
    id: 11,
    name: "深夜瓜铺",
    slug: "shenye-guapu",
    category: "general",
    categoryName: "综合吃瓜",
    tagline: "半夜上线，天亮收摊",
    description:
      "走小圈子路线，内容精选度较高，更新集中在深夜。适合不喜欢被海量信息淹没、想要一点安静围观感的人。",
    heat: 91,
    rating: 4.5,
    reviews: 5540,
    updateScore: 79,
    trustScore: 86,
    tags: ["精选内容", "夜间更新"],
    established: "2022",
    badge: "口碑之选",
  },
  {
    id: 12,
    name: "巷口情报局",
    slug: "xiangkou-qingbaoju",
    category: "general",
    categoryName: "综合吃瓜",
    tagline: "街坊邻里式的闲聊情报站",
    description:
      "话题接地气，节奏轻松，适合不想追热点、只想随便看看今天大家在聊什么的人。深度有限，胜在氛围松。",
    heat: 85,
    rating: 4.2,
    reviews: 3310,
    updateScore: 83,
    trustScore: 78,
    tags: ["氛围轻松", "话题日常"],
    established: "2021",
    badge: "",
  },
];

export const topRated = [
  {
    id: "tr-1",
    name: "硬核说客",
    score: 4.7,
    reason: "长文深度与信息可靠度双高，读起来最扎实。",
    icon: "ri-book-open-line",
  },
  {
    id: "tr-2",
    name: "打工人茶馆",
    score: 4.6,
    reason: "真实投稿多，对选行业、判断公司氛围很有参考价值。",
    icon: "ri-cup-line",
  },
  {
    id: "tr-3",
    name: "码上爆料",
    score: 4.6,
    reason: "把传闻和已证实信息分开写，读起来最省心。",
    icon: "ri-shield-check-line",
  },
  {
    id: "tr-4",
    name: "热浪视界",
    score: 4.7,
    reason: "栏目分类细，找特定剧集或节目讨论效率最高。",
    icon: "ri-layout-masonry-line",
  },
];

export const reviewDimensions = [
  {
    id: "dim-1",
    name: "更新频率",
    weight: "30%",
    icon: "ri-timer-flash-line",
    desc: "统计近 30 天的有效内容发布量与更新间隔是否稳定。",
  },
  {
    id: "dim-2",
    name: "话题广度",
    weight: "25%",
    icon: "ri-broadcast-line",
    desc: "衡量覆盖的话题类型数量，以及是否长期只靠单一热点撑场。",
  },
  {
    id: "dim-3",
    name: "讨论活跃度",
    weight: "25%",
    icon: "ri-chat-smile-2-line",
    desc: "看评论区互动质量，理性讨论与情绪化刷屏的比例。",
  },
  {
    id: "dim-4",
    name: "用户反馈",
    weight: "20%",
    icon: "ri-user-heart-line",
    desc: "汇总站内评分、订阅者回访反馈与长期口碑变化趋势。",
  },
];

export const guideSteps = [
  {
    id: "step-1",
    step: "01",
    title: "先看更新是否稳定",
    desc: "打开首页翻一翻最近三天的内容，如果一半以上是几个月前的旧帖，说明运营已放缓，适合偶尔来逛而不是长期追更。",
    icon: "ri-loop-right-line",
  },
  {
    id: "step-2",
    step: "02",
    title: "看信息有没有出处",
    desc: "靠谱的阵地通常会把消息来源、时间点写清楚，并主动区分「已确认」和「传闻」。只给结论不给依据的，看个乐就好。",
    icon: "ri-link-m",
  },
  {
    id: "step-3",
    step: "03",
    title: "感受一下讨论氛围",
    desc: "点进评论区看十条留言。如果大部分在互相攻击而非讨论事情本身，这个站点的信噪比通常不高。",
    icon: "ri-discuss-line",
  },
  {
    id: "step-4",
    step: "04",
    title: "按兴趣选分类而非只看总榜",
    desc: "总榜热度高不代表适合你。追娱乐的去看娱乐榜，看行业的去职场或科技榜，集中在一个方向更容易找到对味的圈子。",
    icon: "ri-focus-3-line",
  },
];

export const faqs = [
  {
    id: "faq-1",
    question: "瓜圈榜的爆料网站排行是怎么排的？",
    answer:
      "我们综合参考平台的更新频率、话题广度、讨论活跃度与用户反馈四个维度打分，再按加权总分成榜。榜单不接受任何付费上榜，名次只随数据变化。",
  },
  {
    id: "faq-2",
    question: "人气榜、口碑榜和推荐榜有什么区别？",
    answer:
      "人气榜看热度与活跃度，适合想凑热闹的用户；口碑榜看长期评分与真实反馈，适合想找稳定阵地的人；推荐榜是编辑按内容质量与信息可靠度挑选的少量精选。",
  },
  {
    id: "faq-3",
    question: "榜单多久更新一次？",
    answer:
      "综合热度数据每周更新一次，口碑评分每月复核一次。遇到平台长期停更或口碑明显变化时，我们会随时调整名次并在更新日志里说明原因。",
  },
  {
    id: "faq-4",
    question: "怎么判断一个爆料网站值不值得长期看？",
    answer:
      "先看更新是否稳定，再看信息是否标注来源、是否区分传闻与事实；最后看讨论区氛围，理性讨论多、情绪化跟风少的站点通常更值得长期关注。",
  },
  {
    id: "faq-5",
    question: "可以推荐平台加入榜单吗？",
    answer:
      "可以。通过页面底部的反馈表单提交平台名称和推荐理由，我们会在两周内完成评估并回复，符合收录标准的平台会先进入观察名单。",
  },
];

export const voices = [
  {
    id: "voice-1",
    name: "林一苇",
    role: "追剧党 · 3 年用户",
    content:
      "以前找剧集讨论得一个个站翻，现在直接看分类榜就行。热浪视界那一栏帮我省了太多时间。",
    avatar: "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20young%20Chinese%20woman%20with%20short%20hair%20and%20warm%20smile%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20cream%20background%2C%20clean%20vector%20style&width=200&height=200&seq=guaquan-avatar-01&orientation=squarish",
  },
  {
    id: "voice-2",
    name: "周叙",
    role: "硬件爱好者",
    content:
      "科技榜的权重说明写得很清楚，不是拍脑袋排名。码上爆料确实是同类里比较靠谱的一家。",
    avatar: "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20young%20Chinese%20man%20with%20glasses%20and%20calm%20expression%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20cream%20background%2C%20clean%20vector%20style&width=200&height=200&seq=guaquan-avatar-02&orientation=squarish",
  },
  {
    id: "voice-3",
    name: "苏禾",
    role: "应届生 · 求职中",
    content:
      "打工人茶馆我是从榜上找到的，看行业真实分享比看招聘话术有用多了，选方向的时候心里有底。",
    avatar: "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20portrait%20avatar%20of%20a%20cheerful%20young%20Chinese%20woman%20with%20ponytail%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20cream%20background%2C%20clean%20vector%20style&width=200&height=200&seq=guaquan-avatar-03&orientation=squarish",
  },
];

export const updateLog = [
  { id: "log-1", date: "09.08", text: "综合热度榜完成本周更新，深夜瓜铺上升两位。" },
  { id: "log-2", date: "09.01", text: "新增「校园话题」分类，收录 12 个高校讨论板块。" },
  { id: "log-3", date: "08.25", text: "口碑评分复核完成，电竞风眼因信噪比下降扣分。" },
];